import {
  ReceiptRefundIcon,
  ClockIcon,
  CreditCardIcon,
  ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';

/**
 * Single source of truth for the four free-text booking-page policies:
 * bookingPage field key, customer-facing label, and icon.
 * Array order is the display order everywhere policies render.
 */
export const POLICY_META = [
  { key: 'cancellationPolicy', label: 'Cancellation policy', Icon: ReceiptRefundIcon },
  { key: 'lateArrivalPolicy', label: 'Late arrivals', Icon: ClockIcon },
  { key: 'paymentTerms', label: 'Payment', Icon: CreditCardIcon },
  { key: 'serviceRequirements', label: 'Before your visit', Icon: ClipboardDocumentCheckIcon },
];

/**
 * Policies with non-blank text, as [{ key, label, Icon, text }].
 * Pass `keys` to restrict to a subset (POLICY_META order is preserved).
 */
export const getSetPolicies = (bookingPage, keys = null) =>
  POLICY_META.filter(
    ({ key }) => (!keys || keys.includes(key)) && bookingPage?.[key]?.trim()
  ).map((meta) => ({ ...meta, text: bookingPage[meta.key] }));

export const hasAnyPolicy = (bookingPage) => getSetPolicies(bookingPage).length > 0;
